"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.user.list': 'Utenti',
    'route.user.create': 'Aggiungi Utente',
    'route.user.edit': 'Modifica Utente',
};
